import { Injectable } from '@angular/core';

export interface IllustrationDefinition {
  name: string;
  data: string;
}

@Injectable({
  providedIn: 'root',
})
export class IllustrationRegistryService {
  private illustrations = new Map<string, string>();

  registerIllustration(name: string, svgContent: string): void {
    this.illustrations.set(name, svgContent);
  }

  registerIllustrations(illustrations: IllustrationDefinition[]): void {
    illustrations.forEach(({ name, data }) => {
      this.illustrations.set(name, data);
    });
  }

  getIllustration(name: string): string | undefined {
    return this.illustrations.get(name);
  }

  hasIllustration(name: string): boolean {
    return this.illustrations.has(name);
  }

  getRegisteredIllustrations(): string[] {
    return Array.from(this.illustrations.keys());
  }
}
